import { FieldNames } from 'Constants/FieldNames'
import { ErrorAppointmentCode } from 'Pages/orders_design'

export type PaymentStatus = 'paid' | 'readyForPay' | 'notPaid'

export const paymentTooltipStatus: Record<PaymentStatus, string> = {
	paid: 'Услуга оплачена',
	readyForPay: 'Требуется оплата услуги',
	notPaid: 'Доступна оплата услуги',
}

export const fieldsForSocket = [
	{
		field: 'id',
		name: 'Номер заявки',
	},
	{
		field: 'phone',
		name: 'Телефон',
	},
	{
		field: 'last_name',
		name: 'Фамилия',
	},
	{
		field: 'first_name',
		name: 'Имя',
	},
	{
		field: 'middle_name',
		name: 'Отчество',
	},
	{
		field: 'email',
		name: 'Почта',
	},
]

export enum FREE_RBIDOS_REQUEST {
	PKR = 'pkr',
	PKR_LITE = 'pkr_lite',
}

export enum PAID_STATUS {
	INITIAL = 'initial',
	IS_PAID = 'is_paid',
	IS_NOT_PAID = 'is_not_paid',
}

export enum APPOINTMENT_ERROR_MESSAGE {
	NO_SLOTS = 'Not found active slots',
	NO_TICKETS = 'Not found ticket',
}

export enum ErrorAppointmentServerCode {
	e403 = 403,
	e503 = 503,
}

export const FORM_ERROR = {
	[ErrorAppointmentCode.e404]: FieldNames.ADDRESS_DADATA,
}

export const FORM_ERROR_TEXT = {
	[ErrorAppointmentCode.e404]:
		'Место встречи находится вне зоны выездного менеджера. Введите другой адрес',
}

export enum ReserveAccountStatus {
	draft = 'draft',
	reservation = 'reservation',
	status_reservation = 'status_reservation',
	reservation_error = 'reservation_error',
	rejected_reservation = 'rejected_reservation',
	completed = 'completed',
}
